var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.64,
    height: 19.597,
    viewBox: "0 0 19.64 19.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.187,99.73H5.244a.317.317,0,0,0-.317.317v12.667a.317.317,0,0,0,.317.317H9.187a.317.317,0,0,0,.317-.317V100.047A.317.317,0,0,0,9.187,99.73Z",
    transform: "translate(-4.615 -93.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6.341a2.6,2.6,0,1,0,2.6,2.6A2.6,2.6,0,0,0,2.6.341Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.05,94.761a4.631,4.631,0,0,0-3.464,1.454v-.823a.317.317,0,0,0-.317-.317h-3.776a.317.317,0,0,0-.317.317v12.667a.317.317,0,0,0,.317.317h3.934a.317.317,0,0,0,.317-.317v-6.267c0-2.112.574-2.935,2.046-2.935,1.6,0,1.731,1.319,1.731,3.043v6.158a.317.317,0,0,0,.317.317h3.936a.317.317,0,0,0,.317-.317v-6.948C119.089,97.971,118.491,94.761,114.05,94.761Z",
    transform: "translate(-99.449 -88.438)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d0ce2223e205cb5b174ede0a71437ab7.svg";
export { ForwardRef as ReactComponent };